import React, { useState, useEffect, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import ProductSearch from '../../components/ProductSearch'
import ImportProductInput from '../../components/ImportProductInput'
import AntiAgeSummary from '../../components/AntiAgeSummary'
import { Authenticator, useTheme } from "@aws-amplify/ui-react";
import { fetchAuthSession } from "aws-amplify/auth";
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import SEO from '../../components/SEO';
import BeautyButton from '../../components/BeautyButton';
import debounce from 'lodash.debounce';





const CustomAuthHeader = () => {
  const { tokens } = useTheme();
  return (
    <div style={{ padding: `${tokens.space.xl} 0` }}>
      <h1 style={{ textAlign: "center" }}>Sign in or create an account</h1>
    </div>
  );
};

const CustomAuthFooter = () => {
  const { tokens } = useTheme();
  return (
    <div style={{ padding: `${tokens.space.xl} 0` }}>
      <p style={{ textAlign: "center" }}>CosmelytiX &copy; 2025</p>
    </div>
  );
};
const ProductList = ({ products, loading, onDragStart }) => {
  const [visibleCount, setVisibleCount] = useState(10);

  if (loading) {
    return (
      <div className="mt-4 space-y-3">
        {[...Array(5)].map((_, i) => (
          <div key={i} className="flex items-center gap-3 p-2 bg-white rounded shadow-sm border border-[#5F40A1]/50 mb-4 animate-pulse">
            <div className="w-10 h-10 bg-gray-200 rounded" />
            <div className="flex-1 space-y-1">
              <div className="h-4 bg-gray-200 rounded w-2/3" />
              <div className="h-3 bg-gray-200 rounded w-1/3" />
            </div>
          </div>
        ))}
      </div>
    );
  }

  const handleLoadMore = () => {
    setVisibleCount((prev) => prev + 10);
  };

  return (
    <div className="mt-4 space-y-3">
      <Droppable droppableId="recommendations" isDropDisabled={false}>
  {(provided) => (
    <div ref={provided.innerRef} {...provided.droppableProps}>
      {products.slice(0, visibleCount).map((p, index) => (
        <Draggable key={p.id} draggableId={`rec-${p.id}`} index={index}>
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              className="flex items-center justify-between p-2 bg-white rounded shadow-sm border border-[#5F40A1]/50  mb-4"
            >
              <div className="flex items-center gap-3">
                <img
                  src={p.image}
                  alt={p.name}
                  style={{ width: '40px', height: '40px', objectFit: 'cover', borderRadius: '6px' }}
                />
                <div>
                  <a
                    href={`https://cosmelytix.com/products/${p.id}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#5F40A1] font-medium hover:underline"
                  >
                    {p.name}
                  </a>
                  <div className="text-xs text-[#5F40A1]/50">{p.brand}</div>
                </div>
              </div>
              <span className="border border-[#5F40A1]/50 text-xs bg-[#5F40A1]/20 text-[#5F40A1] px-2 py-1 rounded-full">
                general
              </span>
            </div>
          )}
        </Draggable>
      ))}
      {provided.placeholder}
    </div>
  )}
</Droppable>

      {visibleCount < products.length && (
        <div className="text-center mt-4">
          <button
            onClick={handleLoadMore}
            className="bg-[#5F40A1] text-[#E9A969] px-6 py-2 rounded-full hover:bg-[#4709CB] font-semibold shadow-md"
          >
            load more
          </button>
        </div>
      )}
    </div>
  );
};




const ProductDropdown = ({ section, products, onChange }) => {
  const handleAdd = (product) => {
    const updated = [...products, product];
    onChange(section, updated);
  };

  const handleRemove = (index) => {
    const updated = products.filter((_, i) => i !== index);
    onChange(section, updated);
  };

  return (
    <Droppable droppableId={section}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.droppableProps} className="mt-4 p-4 border border-[#5F40A1]/50 rounded-lg bg-pink-50 shadow-sm">
          <ul className="space-y-2">
            {products.map((product, index) => (
              <Draggable key={product.name} draggableId={`${section}-${index}`} index={index}>
                {(provided) => (
                  <li
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    {...provided.dragHandleProps}
                    className="flex justify-between items-center bg-white px-3 py-2 rounded shadow-sm"
                  >
                    <span className="text-pink-700 font-medium">{product.name}</span>
                    <button
                      onClick={() => handleRemove(index)}
                      className="text-[#5F40A1] hover:text-[#4709CB] text-sm font-semibold"
                    >
                      Remove
                    </button>
                  </li>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </ul>
        </div>
      )}
    </Droppable>
  );
};

const API_BASE = import.meta.env.DEV ? '/api' : 'https://api.cosmelytix.com';

const Recommendations = () => {

  // Inside your Recommendations component:
const [searchTerm, setSearchTerm] = useState('');
const [searchResults, setSearchResults] = useState([]);
const [visibleSearchCount, setVisibleSearchCount] = useState(3);
const [isSearching, setIsSearching] = useState(false);

const fetchSearchResults = async (term) => {
  if (!term.trim()) {
    setSearchResults([]);
    return;
  }
  setIsSearching(true);
  try {
    const res = await fetch(`${API_BASE}/products/search?q=${encodeURIComponent(term)}`);
    const data = await res.json();
    setSearchResults(data.products || []);
  } catch (err) {
    console.error(err);
  } finally {
    setIsSearching(false);
  }
};

// Create a debounced version of the fetch
const debouncedSearch = useCallback(debounce(fetchSearchResults, 500), []);

useEffect(() => {
  debouncedSearch(searchTerm);
}, [searchTerm, debouncedSearch]);
  
  const [cosmobagData, setCosmobagData] = useState({
    morning: [],
    daytime: [],
    evening: [],
    night: [],
    anytime: [],
  });

  const [interactionProducts, setInteractionProducts] = useState({ liked: [], saved: [], algorithm: [] });
  const [loadingInteractions, setLoadingInteractions] = useState(true);
  const [authToken, setAuthToken] = useState(null);

  const fetchInteractions = useCallback(async () => {
    try {
      const session = await fetchAuthSession({ forceRefresh: true });
      let token = null;
      if (typeof session.tokens?.idToken === "string") token = session.tokens.idToken;
      else if (session.tokens?.idToken?.jwtToken) token = session.tokens.idToken.jwtToken;
      else if (session.tokens?.idToken?.toString) token = session.tokens.idToken.toString();
      if (!token) return;
      setAuthToken(token);

      const [likeRes, saveRes, addRes] = await Promise.all([
        fetch(`${API_BASE}/interaction?type=like`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_BASE}/interaction?type=save`, { headers: { Authorization: `Bearer ${token}` } }),
        fetch(`${API_BASE}/interaction?type=add`,  { headers: { Authorization: `Bearer ${token}` } }),
      ]);

      const parseRes = async (res) => {
        if (!res.ok) return [];
        const wrapper = await res.json();
        const data = typeof wrapper.body === 'string' ? JSON.parse(wrapper.body) : (wrapper.body ?? wrapper);
        return Array.isArray(data) ? data : [];
      };

      const [liked, saved, added] = await Promise.all([parseRes(likeRes), parseRes(saveRes), parseRes(addRes)]);

      const fetchDetails = (items) => Promise.all(
        items.map(async (item) => {
          const id = item.product_id || item.prod_id || item.id;
          try {
            const res = await fetch(`${API_BASE}/products/${id}`, { headers: { Authorization: `Bearer ${token}` } });
            if (!res.ok) return null;
            const detail = await res.json();
            return { ...detail, id: detail.prod_id || id };
          } catch { return null; }
        })
      ).then(r => r.filter(Boolean));

      const [likedDetails, savedDetails, addedDetails] = await Promise.all([
        fetchDetails(liked), fetchDetails(saved), fetchDetails(added),
      ]);
      setInteractionProducts({ liked: likedDetails, saved: savedDetails, algorithm: addedDetails });
    } catch (err) {
      console.error('Failed to fetch interactions:', err);
    } finally {
      setLoadingInteractions(false);
    }
  }, []);

  useEffect(() => {
    fetchInteractions();
  }, [fetchInteractions]);

  useEffect(() => {
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        fetchInteractions();
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  }, [fetchInteractions]);
  const [products, setProducts] = useState([]);
  const [loadingRecommendations, setLoadingRecommendations] = useState(false);

  useEffect(() => {
    if (!authToken) return;

    const fetchRecommendations = async () => {
      setLoadingRecommendations(true);
      try {
        const addedIds = interactionProducts.algorithm.map(p => p.prod_id || p.id).filter(Boolean);

        if (addedIds.length === 0) {
          setProducts([]);
          return;
        }

        // Call GET /products/{id}/similar for each added product in parallel
        const allResponses = await Promise.all(
          addedIds.map(id =>
            fetch(`${API_BASE}/products/${id}/similar`, { headers: { Authorization: `Bearer ${authToken}` } })
              .then(async r => {
                if (!r.ok) return [];
                const wrapper = await r.json();
                const data = typeof wrapper.body === 'string' ? JSON.parse(wrapper.body) : (wrapper.body ?? wrapper);
                return data.results ?? [];
              })
              .catch(() => [])
          )
        );

        // Flatten and deduplicate across all queries
        const seen = new Set();
        const items = allResponses
          .flat()
          .filter(p => {
            if (seen.has(p.prod_id)) return false;
            seen.add(p.prod_id);
            return true;
          })
          .map(p => ({ id: p.prod_id, name: p.name }));

        // Show names immediately
        setProducts(items);

        // Fetch full details per item progressively
        items.forEach(async (item) => {
          try {
            const detailRes = await fetch(`${API_BASE}/products/${item.id}`, {
              headers: { Authorization: `Bearer ${authToken}` },
            });
            if (!detailRes.ok) return;
            const detail = await detailRes.json();
            setProducts(prev => prev.map(p =>
              p.id === item.id
                ? { ...p, ...detail, id: detail.prod_id || item.id, image: `https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/${detail.image_url}` }
                : p
            ));
          } catch { /* keep name-only entry */ }
        });
      } catch (err) {
        console.error('Failed to fetch recommendations:', err);
      } finally {
        setLoadingRecommendations(false);
      }
    };

    fetchRecommendations();
  }, [authToken, interactionProducts.algorithm]);

  const handleSectionChange = (section, updatedProducts) => {
    setCosmobagData((prev) => ({ ...prev, [section]: updatedProducts }));
  };

  
  const [searchLookup, setSearchLookup] = useState({});

const onDragEnd = (result) => {
  const { source, destination, draggableId } = result;
  if (!destination) return;

  let product;

  // From search results
  if (draggableId.startsWith('search-')) {
    product = searchLookup[draggableId]; // ✅ directly from lookup map
    if (!product) return; // safety check
  }

  // From recommendations (existing logic)
  if (source.droppableId === 'recommendations' && destination.droppableId !== 'recommendations') {
    product = products.find(p => `rec-${p.id}` === draggableId);
  }

  if (product) {
    const sectionProducts = cosmobagData[destination.droppableId] || [];

        // ✅ Prevent duplicates
        const alreadyExists = sectionProducts.some(p => p.id === product.id);
        if (alreadyExists) return;

    handleSectionChange(destination.droppableId, [...sectionProducts, product]);
  }
};

  

  const handleSave = () => {
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#A194A5' }}>
        <SEO title="Recommendations - Cosmelytix" description="Welcome to Cosmelytix Recommendations, your personalized hub for skincare and beauty. Explore General Picks and Personalized Suggestions based on your Skin Passport." url="https://www.cosmelytix.com/recommendations" />
        
        <main className="flex-grow container mx-auto px-4 py-8 gap-8">

<AntiAgeSummary addedProducts={interactionProducts.algorithm} />
{/* <div className="flex-grow container mx-auto px-4 py-8 grid grid-cols-1 md:grid-cols-2 gap-8">
 */}


<div className="w-full py-8 grid grid-cols-1 md:grid-cols-2 gap-8">





          {/* Cosmobag Column */}
<div className="col-span-1">
  <div className="flex items-center justify-between">
    <BeautyButton
      text="cosmobag"
      description={
        'The Cosmobag is your personal collection of cosmetics — the actual products you use in your day-to-day routine and keep in your physical cosmetic bag. It’s designed to help you organize and track all your skincare and beauty items according to when you apply them throughout the day — morning, daytime, evening, or night. Simply add each product to the Cosmobag in the correct time slot, and you’ll always have a clear, personalized beauty regimen ready at hand.'
      }
      type="popup"
    />
    <button
      onClick={handleSave}
      className="bg-[#5F40A1] text-[#E9A969] px-4 py-2 rounded-full hover:bg-[#4709CB] font-semibold shadow-md"
    >
      save
    </button>
  </div>

  <div id="cosmobag-contents" className="mt-6 bg-[#E9A969] rounded-lg p-4 shadow-sm">
  {['morning', 'daytime', 'evening', 'night', 'anytime'].map((section) => {
    const sectionProducts = cosmobagData[section] || [];

    return (
      <div key={section} className="mb-4">
        <BeautyButton text={section} type="dropdown" iconType="plus" />

        <Droppable droppableId={section}>
          {(provided) => (
            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className="mt-2 p-4 border border-[#C58348]/100 rounded-lg bg-[#CDC7DD]/50 shadow-sm min-h-[60px]"
            >
              {sectionProducts.length === 0 ? (
                <div className="text-[#C58348] italic text-sm p-2 border border-dashed border-[#C58348]/90 rounded bg-[#CDC7DD]/30">
                  Drag and drop products here. Can’t find your product? Use our import tool to add products from an external source.
                </div>
              ) : (
                sectionProducts.map((product, index) => (
                  <Draggable key={product.name} draggableId={`${section}-${index}`} index={index}>
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className="flex justify-between items-center bg-white px-3 py-2 rounded shadow-sm mb-2"
                      >
                        <span className="text-[#5F40A1] font-medium">{product.name}</span>
                        <button
                          onClick={() =>
                            handleSectionChange(section, sectionProducts.filter((_, i) => i !== index))
                          }
                          className="text-[#2D1735] hover:text-[#4709CB] text-sm font-semibold"
                        >
                          Remove
                        </button>
                      </div>
                    )}
                  </Draggable>
                ))
              )}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </div>
    );
  })}
</div>


{/* New Sections with Info Buttons */}
{[
  {
    title: 'Added',
    stateKey: 'algorithm',
    description: 'Products that you added to the recommendation algorithm.',
    icon: 'add'
  },
  {
    title: 'Saved',
    stateKey: 'saved',
    description: 'Products you have saved for later review.',
    icon: 'save'
  },
  {
    title: 'Liked',
    stateKey: 'liked',
    description: 'Products you have liked or marked as favorites.',
    icon: 'like'
  }
].map(({ title, stateKey, description, icon }) => {
  const [showCount, setShowCount] = useState(5);
  const sectionProducts = interactionProducts[stateKey] || [];
  const productsToShow = sectionProducts.slice(0, showCount);

  return (
    <div key={stateKey} className="mt-6">
      <BeautyButton text={title} type="popup" description={description} iconType={icon} />

      <div className="mt-3 bg-white rounded-lg p-4 shadow-sm">
        {loadingInteractions ? (
          <div className="space-y-2">
            {[...Array(3)].map((_, i) => (
              <div key={i} className="flex items-center gap-3 bg-gray-50 p-2 rounded animate-pulse">
                <div className="w-10 h-10 bg-gray-200 rounded" />
                <div className="h-4 bg-gray-200 rounded w-1/2" />
              </div>
            ))}
          </div>
        ) : sectionProducts.length === 0 ? (
          <p className="text-gray-500 italic text-sm">
            {icon === "add" ? "You have not added any products yet." : icon === "save" ? "You have not saved any products yet." : "You have not liked any products yet."}
          </p>
        ) : (
          <ul className="space-y-2">
            {productsToShow.map((product, index) => (
              <li key={index} className="flex items-center gap-3 bg-gray-50 p-2 rounded shadow-sm">
                {product.image_url && (
                  <img
                    src={"https://cosmelytix-products-imgs.s3.us-east-1.amazonaws.com/" + product.image_url}
                    alt={product.name}
                    className="w-10 h-10 object-contain rounded"
                  />
                )}
                <a href={`/products/${product.id}`} className="text-[#5F40A1] font-medium hover:underline">
                  {product.name || product.title}
                </a>
              </li>
            ))}
          </ul>
        )}
        {sectionProducts.length > showCount && (
          <div className="mt-2 text-right">
            <button
              onClick={() => setShowCount(prev => prev + 5)}
              className="text-[#5F40A1] hover:underline text-sm font-semibold"
            >
              Load More
            </button>
          </div>
        )}
      </div>
    </div>
  );
})}




</div>




          {/* Recommendations Column */}
          <div className="col-span-1">

{/* Product Search */}
<BeautyButton 
  text="search" 
  type="popup" 
  iconType="info" 
  description="Find products in our database and drag them directly into your Cosmobag."
/>
<div id="search-contents" className="mt-6 bg-[#CDC7DD] rounded-lg  shadow-sm ">

<ProductSearch
  cosmobagData={cosmobagData}
  handleSectionChange={handleSectionChange}
  setSearchLookup={setSearchLookup}
/>
</div>



{/* Import Section */}
<BeautyButton
  text="import"
  type="popup"
  iconType="import"
  description="Paste a product link from Amazon or other supported stores to import it into your Cosmobag. Our team will review the product and add it to the database if it meets our website criteria."
/>
<div className="mt-6  mb-6 bg-[#E9A969] rounded-lg p-4 shadow-sm">
<ImportProductInput handleSectionChange={handleSectionChange} />
</div>




          <BeautyButton text="recommendations" type="popup" iconType="info" description={ <> Types of recommendations: <br /> <br /> General Anti-Age Picks – These are the latest product suggestions based on recent discoveries in cosmetic chemistry and ingredients, gathered from scientific articles and beauty industry research. <br /> <br /> Your Personalized Suggestions – These are tailored just for you, using the features you selected in your Skin Passport. They match your unique needs, goals, and lifestyle for more targeted results. </> } style={{ width: '200px' }} />
            <ProductList products={products} loading={loadingRecommendations} />
          </div>
          </div>
        </main>
      </div>
    </DragDropContext>
  );
};

// Wrap your Recommendations page in Authenticator
const RecommendationsProtected = () => {
  return (
<div className="min-h-screen flex flex-col">
<Header />
<Authenticator components={{ Header: CustomAuthHeader, Footer: CustomAuthFooter }}>

        {({ user, signOut }) =>
          user ? (
            <Recommendations />
          ) : (
            <div className="flex-grow flex items-center justify-center">
              <p className="text-center text-lg text-gray-600">
                Please sign in to access this page.
              </p>
            </div>
          )
        }
      </Authenticator>
      <Footer />
    </div>
  );
};

export default RecommendationsProtected;
